var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('default-list-item',{attrs:{"item":_vm.item}}),_c('ul',_vm._l((_vm.item.children),function(child,i){return _c('li',{key:`menu-${i}`},[(child.heading)?_c('label',[_vm._v(_vm._s(child.heading))]):(child.children && child.children)?_c('default-list-group',{attrs:{"item":child}}):_c('default-list-item',{attrs:{"item":child}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }